//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from "@/components/avatar";
import { api_GetGiftList, api_ReceiveGift, api_ReceiveGiftCDK } from "@/api";
import { mapState, mapMutations } from "vuex";
import { conversion } from "@/tool";
import userImg from "@/assets/images/user/ava_none.jpg";
import vipPrice from "./vipPrice";
export default {
  components: {
    "c-avatar": Avatar,
    "c-vip-price": vipPrice,
  },
  data() {
    return {
      lastViplevel: 12,
      userImg,
      vipCondition: [
        100,
        700,
        2000,
        5000,
        "10k",
        "50k",
        "100k",
        "200k",
        "500k",
        "1000k",
        "2000k",
        "5000k",
      ],
      vipAddOn: [0.2, 0.88, 1.8, 8, 18, 38, 58, 88, 188, 388, 588, 888],
      vipGift: [
        "4-6",
        "25-28",
        "58-88",
        "128-158",
        "368-388",
        "888-1988",
        "1088-2288",
        "1888-6888",
        "5888-12888",
        "12888-21888",
        "38888-48888",
        "58888-68888",
      ],
      vipRollName: [
        "福利roll房",
        "福利roll房",
        "福利roll房",
        "土豪roll房",
        "土豪roll房",
        "土豪roll房",
        "神豪roll房",
        "神豪roll房",
        "神豪roll房",
        "帝豪roll房",
        "帝豪roll房",
        "帝豪roll房",
      ],
    };
  },
  filters: {
    conversion,
  },
  computed: {
    ...mapState(["user"]),
    nextNeed() {
      if (!this.user.nickname) return 0;

      var tnext_need =
        Number(Number(this.vipCondition[this.user.vipLevel]) - Number(this.user.totalRecharge));

      return tnext_need < 0 ? 1 : tnext_need;
    },
    userAavatar() {
      return this.user.avatar
        ? this.$imgfilter(this.user.avatar)
        : this.userImg;
    },
    userVipIconUrl() {
      return (index) => require("@/assets/images/icon/vip/" + index + ".png");
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    GotoReceive(i) {
      if (this.user.vipLevel >= i) {
        this.$emit("on_receive");
      } else {
        this.$store.commit("setPayModal", true);
      }
    },
    GotoRecvWeekly(i) {
      if (this.user.vipLevel == i) {
        this.$emit("on_receive");
      } else {
        //this.$store.commit("setPayModal",true);
        this.$toast.error("領取的紅包與您當前等級不匹配");
      }
    },
  },
};
